import { Badge } from "@mui/material"
import { BsDatabaseUp } from "react-icons/bs"
import React, { useContext, useMemo } from "react"
import SettingsContext from "../../../contexts/settings.context"

const BlobCountBadge = () => {
  const { settingsState } = useContext(SettingsContext)

  const blobCount = useMemo(() => {
    return settingsState.idbUsage?.blobCount || 0
  }, [settingsState.idbUsage?.blobCount])

  // Early return for zero blob count
  if (blobCount === 0) {
    return null
  }

  return (
    <Badge badgeContent={blobCount} color="error" overlap="circular" max={9999}>
      <BsDatabaseUp size={24} />
    </Badge>
  )
}

// Using React.memo ensures the component only re-renders when its props change
export default React.memo(BlobCountBadge)
